import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const services = [
  {
    number: '01',
    title: 'Wiring Harness Design & Engineering',
    content:
      'Schematic design, wiring architecture, and harness drawings are developed using Zuken and Capital H, giving OEMs clear documentation to work from at every stage. CAD-based routing plans wire paths, connector placements, and branch points before assembly begins.',
  },
  {
    number: '02',
    title: 'Design Validation & 3D Simulation',
    content:
      'Harnesses are modeled mechanically and electrically in Creo, Creo Cabling, and CATIA, then validated through 3D routing, DMU, and VLO simulation to confirm clearances, bend radii, and fit within the assembly ahead of production.',
  },
  {
    number: '03',
    title: 'Prototype Development',
    content:
      'Prototype builds support early design refinement and customer validation, allowing changes to be confirmed on a physical sample before committing to full production tooling and volume.',
  },
  {
    number: '04',
    title: 'Custom Harness Manufacturing',
    content:
      'In-house facilities handle cable assemblies, OEM harnesses, battery cables, and PCB harnesses, with shift-based operations that scale production speed and volume to customer requirements.',
  },
  {
    number: '05',
    title: 'Testing, Inspection & Quality Assurance',
    content:
      'Crimp pull-force testing and dedicated continuity testing are performed on every harness, with final inspection and packing carried out under a management system certified to ISO 9001:2015.',
  },
  {
    number: '06',
    title: 'Industries & Applications',
    content:
      'Harness systems are engineered and built for automotive, commercial vehicle, industrial machinery, and renewable energy applications, supporting OEMs across a range of electrical and EV platforms.',
  },
];

const ServicesAccordion = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div className="bg-cogLight min-h-screen py-16 sm:py-24 px-4 font-sans">
      <div className="max-w-5xl mx-auto">
        <div className="mb-12 sm:mb-16">
          <p className="text-xs font-semibold tracking-[0.2em] text-cogCyan uppercase mb-3">
            Our Services
          </p>
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-cogBrand tracking-tight max-w-2xl">
            Engineering &amp; Manufacturing Capabilities
          </h1>
        </div>

        <div className="border-t border-gray-200">
          {services.map((service, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={service.title}
                className="border-b border-gray-200"
              >
                <button
                  onClick={() => toggle(index)}
                  className="w-full flex items-center gap-4 sm:gap-8 py-6 sm:py-8 text-left focus:outline-none group"
                >
                  <span className="text-sm sm:text-base font-semibold text-gray-400 group-hover:text-cogCyan transition-colors duration-200 w-8 sm:w-10 flex-shrink-0 tabular-nums">
                    {service.number}
                  </span>
                  <span className="flex-1 text-lg sm:text-2xl font-semibold text-cogBrand group-hover:text-cogCyan transition-colors duration-200 tracking-tight">
                    {service.title}
                  </span>
                  <span className="flex-shrink-0 w-9 h-9 sm:w-10 sm:h-10 rounded-full border border-gray-300 flex items-center justify-center group-hover:border-cogCyan transition-colors duration-200">
                    <ChevronDown
                      className={`w-4 h-4 sm:w-5 sm:h-5 text-gray-400 group-hover:text-cogCyan transition-transform duration-300 ${
                        isOpen ? 'rotate-180' : ''
                      }`}
                    />
                  </span>
                </button>
                <div
                  className="grid transition-all duration-300 ease-in-out"
                  style={{
                    gridTemplateRows: isOpen ? '1fr' : '0fr',
                    opacity: isOpen ? 1 : 0,
                  }}
                >
                  <div className="overflow-hidden">
                    <div className="flex gap-4 sm:gap-8 pb-6 sm:pb-8">
                      <span className="w-8 sm:w-10 flex-shrink-0" aria-hidden="true" />
                      <p className="flex-1 text-cogBlue/70 leading-relaxed text-sm sm:text-base max-w-2xl pr-9 sm:pr-14">
                        {service.content}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ServicesAccordion;